import {
  makeObservable, observable, action, runInAction
} from 'mobx';
import Update from 'immutability-helper';
import series from 'async/series';
import { convertPropertiesToCamelCase } from '../utils/shared';
// eslint-disable-next-line import/no-cycle
import api from '../api';

class ReportStore {
  isLoading = true;

  id = '';

  name = '';

  reportFileName = '';

  idFile = '';

  deepDive = {};

  deepOverview = {};

  security = {};

  compliance = {};

  uploadingProgress = 0;

  uploadingProgressArray = [];

  uploadedFrontIds = [];

  uploadedCount = 0;

  activeBookmark = 0;

  targetNavBookmark = {};

  projectName = null;

  projectVersionName = null;

  isActiveNav = false;

  isOpenNewScan = false;

  isReloadList = false;

  scanningCount = 0;

  scanningData = [];

  customChecksum = null;

  customSize = null;

  componentKeyword = null;

  bookmarkFileName = null;

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      id: observable,
      name: observable,
      reportFileName: observable,
      idFile: observable,
      deepDive: observable,
      deepOverview: observable,
      security: observable,
      compliance: observable,
      uploadingProgress: observable,
      uploadingProgressArray: observable,
      uploadedCount: observable,
      activeBookmark: observable,
      targetNavBookmark: observable,
      projectName: observable,
      projectVersionName: observable,
      isActiveNav: observable,
      isOpenNewScan: observable,
      isReloadList: observable,
      scanningCount: observable,
      scanningData: observable,
      customChecksum: observable,
      customSize: observable,
      uploadedFrontIds: observable,
      componentKeyword: observable,
      bookmarkFileName: observable,
      setFile: action,
      resetFile: action,
      updateProgress: action,
      updateProgressArray: action,
      setUploadingProgressArray: action,
      setName: action,
      setId: action,
      setSecurity: action,
      setCompliance: action,
      setReportFileName: action,
      setUploadedCount: action,
      setActiveBookMark: action,
      setNavBookmark: action,
      completeNavBookmark: action,
      setReload: action,
      initReload: action,
      initNavigationCount: action,
      syncNewScanModal: action,
      setScanningCount: action,
      setScanning: action,
      removeScanning: action,
      setCustomApply: action,
      initScanningData: action,
      addFrontId: action,
      initFrontId: action,
      updateSearchKeyword: action,
      initCustomApply: action,
      initSearchKeyword: action
    });
  }

  setFile(node) {
    this.name = node.name;
    this.idFile = node.id;
    this.isLoading = true;

    series(
      [
        (callback) => {
          api.getDeepOverview(this.id, this.idFile).then((response) => {
            callback(null, response.response);
          });
        },
        (callback) => {
          api.getDeepHtmlList(this.id, this.idFile).then((response) => {
            callback(null, response.data.response);
          });
        },
      ],
      (err, [deepOverview, deepHtmlList]) => {
        this.deepOverview = convertPropertiesToCamelCase(deepOverview);
        this.deepHtmlList = deepHtmlList;
        this.isLoading = false;
      }
    );
  }

  resetFile() {
    this.name = '';
    this.idFile = '';
    this.isLoading = true;
  }

  updateProgress(progress) {
    this.uploadingProgress = progress;
  }

  setUploadingProgressArray(newState) {
    this.uploadingProgressArray = newState;
  }

  updateProgressArray = async (progress, fid, type, error) => {
    const newFileData = {
      status: progress,
      frontId: fid,
      type,
    };

    if (this.uploadingProgressArray.length === 0) {
      runInAction(() => {
        this.uploadingProgressArray.push(newFileData);
      });
    } else if (error) {
      const filteredData = this.uploadingProgressArray.filter((file) => {
        return file.frontId !== fid;
      });

      runInAction(() => {
        this.uploadingProgressArray = filteredData;
      });
    } else {
      const updatedFileIndex = this.uploadingProgressArray.findIndex((file) => {
        return file.frontId === fid;
      });

      if (updatedFileIndex === -1) {
        runInAction(() => {
          this.uploadingProgressArray.push(newFileData);
        });
      } else {
        const updatedData = Update(this.uploadingProgressArray[updatedFileIndex], {
          status: {
            $set: progress,
          },
          frontId: {
            $set: fid,
          },
        });

        const newData = Update(this.uploadingProgressArray.slice(), {
          $splice: [[updatedFileIndex, 1, updatedData]],
        });

        runInAction(() => {
          this.uploadingProgressArray = newData;
        });
      }
    }
  };

  updateScanningStatus = async (obj) => {
    api
      .getNewScanUpdateCheck(obj)
      .then((res) => {
        const data = res.data.response;
        const scanningStatus = data.scanning_status;
        const frontIds = this.uploadingProgressArray.map((item) => {
          return item.frontId;
        });
        scanningStatus.map((item) => {
          runInAction(() => {
            if (frontIds.indexOf(item.front_id) !== -1) {
              this.updateProgressArray(item.uploaded_progress, item.front_id, 'url');
            }
          });
          return null;
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  addFrontId = async (id) => {
    this.uploadedFrontIds.push(id);
  };

  initFrontId = async () => {
    this.uploadedFrontIds = [];
  };

  setName(name) {
    this.name = name;
  }

  setId(id) {
    this.id = id;
  }

  setSecurity(data) {
    this.security = data;
  }

  setCompliance(data) {
    this.compliance = data;
  }

  setReportFileName(name) {
    this.reportFileName = name;
  }

  setUploadedCount() {
    this.uploadedCount++;
  }

  setActiveBookMark() {
    this.activeBookmark++;
  }

  setNavBookmark = (ids, projectName, projectVersionName, fileName) => {
    this.targetNavBookmark = ids;
    this.projectName = projectName || null;
    this.projectVersionName = projectVersionName || null;
    this.bookmarkFileName = fileName || null;
    this.isActiveNav = true;
  };

  completeNavBookmark = () => {
    this.targetNavBookmark = {};
    this.projectName = null;
    this.projectVersionName = null;
    this.bookmarkFileName = null;
    this.isActiveNav = false;
  };

  setReload() {
    this.isReloadList = true;
  }

  initReload() {
    this.isReloadList = false;
  }

  initNavigationCount() {
    this.uploadedCount = 0;
    this.activeBookmark = 0;
  }

  syncNewScanModal(value) {
    this.isOpenNewScan = value;
  }

  setScanningCount(value) {
    this.scanningCount = value;
  }

  setScanning = async (obj) => {
    //value {front_id, status} // status: 'upload', 'scanning', 'complete'
    if (this.scanningData.length === 0) {
      runInAction(() => {
        this.scanningData.push(obj);
      });
    } else {
      const updatedIndex = this.scanningData.findIndex((item) => {
        return item.front_id === obj.front_id;
      });

      if (updatedIndex === -1) {
        runInAction(() => {
          this.scanningData.push(obj);
        });
      } else {
        const updatedData = Update(this.scanningData[updatedIndex], {
          front_id: {
            $set: obj.front_id,
          },
          status: {
            $set: obj.status,
          },
        });

        const newData = Update(this.scanningData.slice(), {
          $splice: [[updatedIndex, 1, updatedData]],
        });
        runInAction(() => {
          this.scanningData = newData;
        });
      }
    }
  };

  initScanningData() {
    this.scanningData = [];
  }

  removeScanning(value) {
    const fileId = value.front_id;
    const newData = this.scanningData.filter((item) => {
      return item.front_id !== fileId;
    });
    this.scanningData = newData;
  }

  setCustomApply(rowData) {
    this.customChecksum = rowData.key1 || null;
    this.customSize = rowData.key2 || null;
    this.isActiveNav = true;
  }

  initCustomApply() {
    this.customChecksum = null;
    this.customSize = null;
    this.isActiveNav = false;
  }

  updateSearchKeyword(rowData) {
    this.componentKeyword = rowData.key1 || null;
    this.isActiveNav = true;
  }

  initSearchKeyword() {
    this.componentKeyword = null;
    this.isActiveNav = false;
  }
}

export default ReportStore;
